import React, { useEffect, useState } from "react";
import { useAppServices } from "../../../../../../../hook/services";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const AddTask = ({
  handleRefresh,
  data,
  editIndex = null,
  selectedTab = null,
  defaultTasks = [],
}) => {
  const AppService = useAppServices();
  const { companyId, type } = useParams();
  const handler =
    type === "agency" || type === "location"
      ? AppService.sidenav_customizer_main_level
      : type === "group"
      ? AppService.sidenav_customizer_custom_level
      : AppService.sidenav_customizer_saas_level;

  const isEdit = editIndex !== null && selectedTab;
  const [open, setOpen] = useState(false);
  const [trueUrl, setTrueUrl] = useState(false);
  const [formData, setFormData] = useState({
    description: "",
    buttonText: "",
    selector: "",
    imageUrl: "",
    tagline: "",
    buttonLink: "",
    type: "new",
  });

  useEffect(() => {
    if (isEdit) {
      setFormData(selectedTab);
    }
  }, [isEdit, selectedTab]);

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setFormData({
      description: "",
      buttonText: "",
      selector: "",
      imageUrl: "",
      tagline: "",
      buttonLink: "",
      type: "new",
    });
    setTrueUrl(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      formData.type === "new" &&
      !formData.buttonLink.startsWith("https://")
    ) {
      setTrueUrl(true);
      return;
    }

    const launchpads = data?.launchpads?.length
      ? [...data.launchpads]
      : defaultTasks;

    if (isEdit) launchpads[editIndex] = formData;
    else launchpads.push(formData);

    const payload = {
      launchpads,
      companyId,
      type,
      ...(data?._id && { _id: data._id }),
    };

    const { response } = await handler[data?._id ? "update" : "create"]({
      payload,
    });

    if (response) {
      handleRefresh();
      toast.success(isEdit ? "Task updated!" : "Task added!");
      handleClose();
    } else {
      toast.error("Error saving task");
    }
  };

  return (
    <>
      {isEdit ? (
        <button
          type="button"
          className="mm-btn mm-btn--ghost"
          style={{ padding: "7px 10px" }}
          title="Edit"
          onClick={handleOpen}
        >
          <i className="bi bi-pencil"></i>
        </button>
      ) : (
        <button
          type="button"
          className="mm-trigger mm-trigger--primary d-inline-flex align-items-center"
          title="Add Task"
          onClick={handleOpen}
        >
          <span className="mm-trigger-icon d-inline-flex align-items-center justify-content-center" aria-hidden="true">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
          </span>
          <span className="mm-trigger-label">Add task</span>
        </button>
      )}

      {open && (
        <div className="mm-overlay" onMouseDown={handleClose}>
          <div
            className="mm-dialog"
            role="dialog"
            aria-modal="true"
            onMouseDown={(e) => e.stopPropagation()}
          >
            <header className="mm-header d-flex justify-content-between align-items-center">
              <div>
                <h5 className="mm-title mb-0">{isEdit ? "Edit task" : "Add task"}</h5>
                <p className="mm-subtitle mb-0">
                  Configure a launchpad action for your sub-accounts.
                </p>
              </div>
              <button type="button" className="mm-close" onClick={handleClose} aria-label="Close">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </header>

            <div className="mm-body">
                <div className="mm-field">
                  <label className="mm-label">Image URL</label>
                  <input
                    type="text"
                    name="imageUrl"
                    className="mm-input"
                    value={formData.imageUrl}
                    onChange={handleChange}
                    placeholder="https://"
                  />
                </div>

                <div className="mm-field">
                  <label className="mm-label">Description</label>
                  <input
                    type="text"
                    name="description"
                    className="mm-input"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                <div className="mm-field">
                  <label className="mm-label">Tagline</label>
                  <input
                    type="text"
                    name="tagline"
                    className="mm-input"
                    value={formData.tagline}
                    onChange={handleChange}
                  />
                </div>

                <div className="mm-field">
                  <label className="mm-label">Button text</label>
                  <input
                    type="text"
                    name="buttonText"
                    className="mm-input"
                    value={formData.buttonText}
                    onChange={handleChange}
                  />
                </div>

                <div className="mm-field">
                  <label className="mm-label">
                    Button selector
                    <span className="mm-label-hint">
                      {formData.type === "default"
                        ? "Locked — this is a built-in task and its selector cannot be changed."
                        : "Ensure the ID is unique and does not conflict with other element IDs."}
                    </span>
                  </label>
                  <input
                    type="text"
                    name="selector"
                    className="mm-input"
                    value={formData.selector}
                    onChange={handleChange}
                    readOnly={formData.type === "default"}
                    disabled={formData.type === "default"}
                    style={
                      formData.type === "default"
                        ? { background: "#f1f5f9", cursor: "not-allowed" }
                        : {}
                    }
                  />
                </div>

                {formData.type === "new" && (
                  <div className="mm-field">
                    <label className="mm-label">Button link (HTTPS only)</label>
                    <input
                      type="text"
                      name="buttonLink"
                      className="mm-input"
                      value={formData.buttonLink}
                      onChange={handleChange}
                      required
                      style={trueUrl ? { borderColor: "#ef4444" } : {}}
                    />
                    {trueUrl && (
                      <small className="text-danger">Please enter a valid HTTPS URL.</small>
                    )}
                  </div>
                )}
              </div>

            <footer className="mm-footer d-flex justify-content-end gap-2">
              <button type="button" className="mm-btn mm-btn--ghost" onClick={handleClose}>
                Cancel
              </button>
              <button type="button" className="mm-btn mm-btn--primary" onClick={handleSubmit}>
                {isEdit ? "Save changes" : "Add task"}
              </button>
            </footer>
          </div>
        </div>
      )}
    </>
  );
};

export default AddTask;
